import { defineStore } from 'pinia';
import { VOUCHER, VOUCHER_CONTENT } from '@/constants';
import ItemConfigurationService from '@/service/ItemConfigurationService';

export const useItemConfigurationStore = defineStore('itemConfigurationStore', {
  state: () => ({
    itemConfigurationItem: {},
    status: false,
    emailUrls: {},
    voucherConfig: {
      voucherContent: {
        templateEn: '',
        templateFr: ''
      },
      emailContent: {
        templateEn: '',
        templateFr: ''
      }
    },
    signatures: [],
    signature: {},
    signatureOptions: []
  }),
  getters: {
    selectStatus: (state) => state.status,
    selectItemUrl: (state) => state.itemConfigurationItem,
    selectVoucherConfig: (state) => state.voucherConfig,
    selectSignature: (state) => state.signature,
    selectSignatureOptions: (state) => state.signatureOptions
  },
  actions: {
    async getUrlConfigurationItem() {
      const Service = new ItemConfigurationService();
      const res = await Service.getUrlConfigurationItem();
      this.updateGetUrl(res?.data);
    },

    async updateUrlByUrlType(payload: any) {
      const Service = new ItemConfigurationService();
      try {
        const res = await Service.updateUrlByUrlType(payload);
        this.updateStatus(true);
        return res?.data;
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async updateVoucher(type: any, payload: any) {
      const Service = new ItemConfigurationService();
      let res;
      try {
        if (type === VOUCHER) {
          payload.value.emailContent.eType = VOUCHER;
          res = await Service.updateVoucher(payload.value.emailContent);
        } else {
          payload.value.voucherContent.eType = VOUCHER_CONTENT;
          res = await Service.updateVoucher(payload.value.voucherContent);
        }
        this.updateStatus(true);
        return res?.data;
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async getVoucher(payload: any) {
      const Service = new ItemConfigurationService();
      try {
        const res = await Service.getVoucher(payload);
        if (res?.data?.eType === VOUCHER) {
          this.voucherConfig.emailContent = res?.data;
        } else {
          this.voucherConfig.voucherContent = res?.data;
        }
        this.updateStatus(true);
        return res?.data;
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async previewVoucherContent(payload: any) {
      const Service = new ItemConfigurationService();
      try {
        const res = await Service.previewVoucherContent(payload);
        this.updateStatus(true);
        return res?.data;
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async saveSignature(payload: any) {
      const Service = new ItemConfigurationService();
      try {
        const res = await Service.saveSignature(payload);
        this.updateStatus(true);
        return res?.data;
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async getAllSignature() {
      const Service = new ItemConfigurationService();
      try {
        const res = await Service.getAllSignature();
        this.updateStatus(true);
        this.signatures = res?.data;
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async getSignatureById(id: any) {
      const Service = new ItemConfigurationService();
      try {
        const res = await Service.getSignatureById(id);
        this.updateStatus(true);
        this.signature = res?.data;
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async deleteSignatureBy(id: any) {
      const Service = new ItemConfigurationService();
      try {
        await Service.deleteSignatureBy(id);
        this.updateStatus(true);
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async updateSignatureStatus(id: any, sts: any) {
      const Service = new ItemConfigurationService();
      try {
        await Service.updateStsSignature(id, sts);
        this.updateStatus(true);
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async getActiveSignature(sts: any) {
      const Service = new ItemConfigurationService();
      try {
        const res = await Service.getActiveSignature(sts);
        this.signatureOptions = res?.data;
        this.updateStatus(true);
      } catch (e) {
        this.updateStatus(false);
      }
    },

    updateStatus(payload: any) {
      this.status = payload;
    },

    updateGetUrl(payload: any) {
      this.itemConfigurationItem = payload;
    },

    async getListEmailUrls() {
      const Service = new ItemConfigurationService();
      const res = await Service.getListUrlEmail();
      this.emailUrls = res?.data;
    },

    async updateUrlEmailByUrlType(payload: any) {
      const Service = new ItemConfigurationService();
      try {
        const res = await Service.updateUrlEmailByUrlType(payload);
        this.updateStatus(true);
        return res?.data;
      } catch (e) {
        this.updateStatus(false);
      }
    },

    async getListAgency() {
      const Service = new ItemConfigurationService();
      const res = await Service.getListAgency();
      return res?.data;
    },

    async addListAgency(payload: any) {
      const Service = new ItemConfigurationService();
      const res = await Service.addListAgency(payload);
      return res?.data;
    },

    async getAgencyById(id: string) {
      const Service = new ItemConfigurationService();
      const res = await Service.getAgencyById(id);
      return res?.data;
    },

    async deleteAgency(id: string) {
      const Service = new ItemConfigurationService();
      const res = await Service.deleteAgency(id);
      return res?.data;
    }
  }
});
